import WelcomeBox from './containers/WelcomeBox';
import Button from '../../../components/Button';
import JobsPanel from './containers/JobsPanel';
import { useNavigate } from 'react-router-dom';
import Skeleton from './containers/Skeleton';
import styles from './style.module.scss';
import { useEffect } from 'react';
import {
    useDispatch,
    useSelector,
} from '../../../store/store';
import {
    getJobsThunk,
    getProfileDataThunk,
} from '../../../store/workspace/thunks';
import {
    ListStarCircleIcon,
    BoardCheckCircleIcon,
} from '../../../assets/icons';
import {
    setExamStatics,
    setPlansModalShow,
    setContactAdminModal,
} from '../../../store/workspace/slice';
import {
    selectProfile,
    selectPostedJobs,
    selectInitialLoading,
    selectJobsSearchShow,
    selectFetchingProfile,
    selectFetchingPostedJobs,
} from '../../../store/workspace/selectors';

function Dashboard() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const profile = useSelector(selectProfile);
    const jobs = useSelector(selectPostedJobs);
    const jobsSearchShow = useSelector(selectJobsSearchShow);
    const initialLoading = useSelector(selectInitialLoading);
    const fetchingJobs = useSelector(selectFetchingPostedJobs);
    const fetchingProfile = useSelector(selectFetchingProfile);

    useEffect(() => {
        dispatch(getJobsThunk({}));
        dispatch(getProfileDataThunk());
        dispatch(setExamStatics(null));
    }, []);

    const postNewJob = () => {
        if (!profile) return;

        if (profile.postCounter === 0) {
            if (profile.userRole === 'owner') {
                dispatch(setPlansModalShow(true));
            } else {
                dispatch(setContactAdminModal(true));
            }
        } else {
            navigate('postjob');
        }
    };

    return (
        <div className={styles.container}>
            <Button
                type='Primary'
                onClick={postNewJob}
                className={styles.CTA}
                text='+ Create Job Post'
                loading={fetchingProfile}
            />

            <div className={styles.overview}>
                <div className={styles.overview_card}>
                    <div className={styles.overview_card_content}>
                        <h3>Job Posts</h3>
                        <h2>{profile?.job.used} Posted / {profile?.job.all} Total</h2>
                        <h5><b>{(profile?.job.all || 0) - (profile?.job.used || 0)}</b> Job post credits</h5>
                    </div>
                    <BoardCheckCircleIcon />
                </div>
                <div className={styles.overview_card}>
                    <div className={styles.overview_card_content}>
                        <h3>Applicants</h3>
                        <h2>{profile?.applicant.used} Applied / {profile?.applicant.all} Total</h2>
                        <h5><b>{(profile?.applicant.all || 0) - (profile?.applicant.used || 0)}</b> Applicants credits</h5>
                    </div>
                    <ListStarCircleIcon />
                </div>
            </div>

            <div
                className={styles.mainContent}
                data-jobs-search-show={jobsSearchShow}
            >
                {!initialLoading &&
                    jobs.length > 0 &&
                    <JobsPanel
                        jobs={jobs}
                        postNewJob={postNewJob}
                        fetchingJobs={fetchingJobs}
                        searchShow={jobsSearchShow}
                        fetchingProfile={fetchingProfile}
                    />}

                {initialLoading &&
                    fetchingJobs &&
                    <Skeleton />}

                {!fetchingJobs &&
                    !jobsSearchShow &&
                    jobs.length === 0 &&
                    <WelcomeBox postNewJob={postNewJob} />}
            </div>
        </div>
    );
};

export default Dashboard;
